<script>
import {BTh} from "bootstrap-vue";

export default {
  extends: BTh
};
</script>